// extracted by mini-css-extract-plugin
export default {"main_container":"app_main_container__ak8da","burger_constructor":"app_burger_constructor__Y+hMo","burger_ingredients":"app_burger_ingredients__0VZPa","Loader":"app_Loader__rQHv4"};